module.exports = __webpack_public_path__ + "static/media/tapan.406c1188.jpg";